import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { useDeviceSelectors } from 'react-device-detect';
import { useIntl } from 'react-intl';
import { processFormError } from '../../../utils/processFormError';
import Loader from '../../../components/base/Loader/Loader';
import { Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { authorizedLogin } from '../actions';
import { responseLogWithNotification } from '../../../utils/utils';
import { calculateBaseRoute } from '../../../utils/routeByRoles';
import { getAuthorizedData } from '../reducer';
import { LOCAL_STORAGE_UPDATE_PERIOD } from '../../../configs/names';

export default function LoginPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    loggedIn, loginProcess, loadingForgotPassword, loadingRedirectUrl,
  } = useSelector(getAuthorizedData);
  const [selectors] = useDeviceSelectors(window.navigator.userAgent);
  const { formatMessage } = useIntl();
  const { isMobile } = selectors;
  useEffect(() => {
    if (loggedIn) {
      const baseRoute = calculateBaseRoute(true, [], null, isMobile, true);
      navigate(baseRoute || '/');
    }
  }, []);
  const [error, setError] = useState('');

  const handleLogin = values => {
    setError('');
    Object.keys(localStorage).forEach(key => {
      if (key.includes('filter')) {
        localStorage.removeItem(key);
      }
    });
    window.localStorage.setItem(LOCAL_STORAGE_UPDATE_PERIOD, 300);
    dispatch(authorizedLogin()).catch(response => {
      responseLogWithNotification(response, formatMessage({ id: 'app.login' }), formatMessage({ id: 'error.default' }));
      setError(processFormError(response));
    });
  };

  return (
    <>
      <Loader loading={loginProcess || loadingForgotPassword || loadingRedirectUrl} />
      <div className="login-page-wrapper">
        <div className="login-background" />
        <div className="login-page">
          <div className="form-block-wrapper">
            <div className="form-block">
              <div className="login-block">
                <div className="header">
                  {formatMessage({ id: 'menu.login' })}
                </div>
                <div className="asu-login-button" onClick={handleLogin}>
                  <div className="asu-login-button-header">Вход через</div>
                  <div className="asu-login-button-body">
                    АСУ ГПТ
                    <Icons icon="arrow-down" customIcon className="arrow" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
